import { useTranslation } from "react-i18next";

import { Form } from "react-bootstrap";

function RCFInvoiceForm({ rcfInvoice, setRCFInvoice }) {
  const { t } = useTranslation();
  return (
    <div className="invoice-page__modal_form_invoice-container">
      <Form.Group>
        <Form.Label>Localisation de la maison: </Form.Label>
        <Form.Control
          label="text"
          as="textarea"
          rows={8}
          value={rcfInvoice.house_location}
          onChange={(e) =>
            setRCFInvoice({
              ...rcfInvoice,
              house_location: e.target.value,
            })
          }
        />
      </Form.Group>

      <Form.Group className="u-mb-small">
        <Form.Label>Information sur la famille:</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={rcfInvoice.information_on_familly}
          onChange={(e) =>
            setRCFInvoice({
              ...rcfInvoice,
              information_on_familly: e.target.value,
            })
          }
        />
      </Form.Group>
    </div>
  );
}

export default RCFInvoiceForm;
